import {
  DEFAULT_THEME_PREFERENCE,
  THEME_STORAGE_KEY,
  isThemePreference,
  resolveTheme,
} from '@mcikm-vote/shared';
import type { ResolvedTheme, ThemePreference } from '@mcikm-vote/shared';

/**
 * Speicherung und Anwendung der Dark-/Light-Einstellung (§21).
 *
 * Die Einstellung wird ausschließlich lokal im Browser gehalten. Sie wird nicht an den Server
 * übertragen, nicht protokolliert und nicht an Token oder Veranstaltung gebunden.
 */

/** Liest die gespeicherte Einstellung. Fällt bei Fehlern auf die Systemeinstellung zurück. */
export function readThemePreference(): ThemePreference {
  try {
    const gespeichert = window.localStorage.getItem(THEME_STORAGE_KEY);
    return isThemePreference(gespeichert) ? gespeichert : DEFAULT_THEME_PREFERENCE;
  } catch {
    // Blockierter Speicher (etwa im privaten Modus) darf die Anwendung nicht beeinträchtigen.
    return DEFAULT_THEME_PREFERENCE;
  }
}

/** Speichert die Einstellung. Ein Fehlschlag ist unschädlich und wird stillschweigend hingenommen. */
export function writeThemePreference(preference: ThemePreference): void {
  try {
    window.localStorage.setItem(THEME_STORAGE_KEY, preference);
  } catch {
    /* bewusst ohne Wirkung */
  }
}

export function systemPrefersDark(): boolean {
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

/** Setzt das Erscheinungsbild am Wurzelelement. */
export function applyResolvedTheme(theme: ResolvedTheme): void {
  document.documentElement.setAttribute('data-theme', theme);
}

/** Ermittelt das anzuwendende Erscheinungsbild aus der gespeicherten Einstellung. */
export function currentResolvedTheme(): ResolvedTheme {
  return resolveTheme(readThemePreference(), systemPrefersDark());
}
